const ITEMS = [
  "MINDRAY BA-88A",
  "CALIBRACIÓN FOTOMÉTRICA",
  "ESPECTROFOTOMETRÍA",
  "BLOQUE ÓPTICO",
  "FLUÍDICA DE PRECISIÓN",
  "DIAGNÓSTICO DE FALLAS",
  "PRUEBAS DE DESEMPEÑO",
  "ACCESO DE POR VIDA",
];

export const Marquee = () => (
  <div
    data-testid="tech-marquee"
    className="relative overflow-hidden border-y border-white/5 bg-[#080D16] py-5"
  >
    <div className="marquee-track flex w-max items-center gap-12">
      {[...ITEMS, ...ITEMS].map((t, i) => (
        <span
          key={i}
          className="flex items-center gap-12 font-tech text-xs tracking-[0.35em] text-slate-500"
        >
          {t}
          <span className="text-cyan-500/60">◆</span>
        </span>
      ))}
    </div>
  </div>
);
